// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shadow-box {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0,0,0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    margin-top: 10px;
    display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;
}

.highlight {
  color: black
}

.plain {
  color: #92a195
}

.status_selected {
  color: #a85934
}

:host ::ng-deep .mat-form-field {
  font-family: garamond !important;
  color: black;
  font-weight: 400;
}

:host ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0px;
}

:host ::ng-deep .mat-form-field-flex{
  padding: 0px !important;
}

:host ::ng-deep .mat-select-value{
  text-align:center
}


:host ::ng-deep .mat-form-field-underline {
  display: none;
}

.open_pdf {
  background-color: #262626;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/candidates-workflow/candidates-workflow.component.css"],"names":[],"mappings":"AAAA;IACI,sFAAsF;IACtF,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,CAAC,qBAAqB,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB;AACvI;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":[".shadow-box {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0,0,0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n    display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;\n}\n\n.highlight {\n  color: black\n}\n\n.plain {\n  color: #92a195\n}\n\n.status_selected {\n  color: #a85934\n}\n\n:host ::ng-deep .mat-form-field {\n  font-family: garamond !important;\n  color: black;\n  font-weight: 400;\n}\n\n:host ::ng-deep .mat-form-field-wrapper {\n  padding-bottom: 0px;\n}\n\n:host ::ng-deep .mat-form-field-flex{\n  padding: 0px !important;\n}\n\n:host ::ng-deep .mat-select-value{\n  text-align:center\n}\n\n\n:host ::ng-deep .mat-form-field-underline {\n  display: none;\n}\n\n.open_pdf {\n  background-color: #262626;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
